export const novelStorefrontScriptHasRunProperty = "__NOVEL_STOREFRONT_SCRIPT_HAS_RUN__";
export const novelStorefrontStyleHasLoadedProperty = "__NOVEL_STOREFRONT_STYLE_HAS_LOADED__";
export const novelOrderStatusScriptHasRunProperty = "__NOVEL_ORDER_STATUS_SCRIPT_HAS_RUN__";
export const novelDiscountCodeLocalStorageKey = "__novel_discount__";
export const novelPriceRuleIdLocalStorageKey = "__novel_price_rule_id__";
